import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Helmet } from 'react-helmet';
import * as DataList from 'components/DataList';
import SettingsPage from 'components/SettingsPage';
import CompanyDetailsForm from 'components/Preference/CompanyDetailsForm';

// Settings > Company details (/preferences/company_details).
@inject('preferenceStore', 'quickbooksStore') @observer
class CompanyDetails extends Component {

  componentDidMount() {
    const { preferenceStore, quickbooksStore } = this.props;
    const items = quickbooksStore.quickbooksItems.objects;
    if (items && items.length === 0) {
      quickbooksStore.loadQuickbooksItems();
    }
    preferenceStore.loadTenant().catch(() => undefined);
  }

  render() {
    const { preferenceStore } = this.props;
    const { isLoading, isError, object } = preferenceStore.tenant;
    let content = null;
    if (object && object.attributes) {
      content = <CompanyDetailsForm key={object.id} />;
    } else if (isError && !isLoading) {
      content = (
        <DataList.Notice
          tone="error"
          icon="error"
          role="alert"
          title="Company details couldn't be loaded"
          message="Something went wrong on our side. Try again in a moment."
          actions={[{ label: 'Try again', icon: 'refresh', onClick: () => preferenceStore.loadTenant().catch(() => undefined), primary: true }]}
        />
      );
    } else if (isLoading) {
      content = (
        <div className="sp-card sp-card--loading" role="status" aria-label="Loading company details">
          <span className="dl-bone" style={{ width: 220, height: 16 }} />
          <span className="dl-bone" style={{ width: '100%', height: 40 }} />
          <span className="dl-bone" style={{ width: '100%', height: 40 }} />
          <span className="dl-bone" style={{ width: 160, height: 36 }} />
        </div>
      );
    }
    return (
      <React.Fragment>
        <Helmet>
          <title>Company details | FieldNexus</title>
        </Helmet>
        <SettingsPage
          title="Company details"
          description="Your business details, documents and defaults for the team."
        >
          {content}
        </SettingsPage>
      </React.Fragment>
    );
  }
}

export default CompanyDetails;
